import Component from '../../components/component/component';

import './recipient.scss';
export default class Recipient extends Component {
    static initSelector: string = '.recipient';

    recipientTypeInputSelf: HTMLInputElement;
    recipientTypeInputOther: HTMLInputElement;
    recipientSenderSection: HTMLDivElement;
    recipientSenderShowNameTrue: HTMLInputElement;
    recipientSenderShowNameFalse: HTMLInputElement;
    recipientSenderNameInput: HTMLInputElement;
    recipientEmailInput: HTMLInputElement;
    selfOriginalEmail: string;
    otherEmailCache: string;

    constructor(target: HTMLElement) {
        super(target);

        this.recipientTypeInputSelf = this.element.querySelector(
            '.recipient__type .recipient-type-self',
        );

        this.recipientTypeInputOther = this.element.querySelector(
            '.recipient__type .recipient-type-other',
        );

        this.recipientSenderSection = this.element.querySelector(
            '.recipient__sender-details-section',
        );

        this.recipientSenderShowNameTrue = this.element.querySelector(
            '.recipient__show-sender-name .show-sender-name-true',
        );

        this.recipientSenderShowNameFalse = this.element.querySelector(
            '.recipient__show-sender-name .show-sender-name-false',
        );

        this.recipientSenderNameInput = this.element.querySelector('.recipient-sender-name');

        this.recipientEmailInput = this.element.querySelector(
            '.recipient__email-input',
        );

        this.selfOriginalEmail = '';
        this.otherEmailCache = '';

        this.init();
    }

    focusEmailField(): void {
        this.recipientEmailInput.focus();
        this.recipientEmailInput.select();
        this.recipientEmailInput.dispatchEvent(new Event('input'));
    }

    onSelectSelf(evt: Event): void {
        this.recipientSenderSection.style.display = 'none';
        if (evt){
            this.recipientEmailInput.value = this.selfOriginalEmail;
        }
        this.focusEmailField();
    }

    onSelectOther(evt: Event): void {
        this.recipientSenderSection.style.display = 'block';
        if (evt){
            this.recipientEmailInput.value = this.otherEmailCache;
        }
        this.focusEmailField();
    }

    onSelectShowNameTrue(): void {
        this.recipientSenderNameInput.style.display = 'block';
    }

    onSelectShowNameFalse(): void {
        this.recipientSenderNameInput.style.display = 'none';
    }

    onChangeEmailValue(evt: InputEvent): void {
        if (!this.recipientTypeInputOther.checked) {
            return;
        }

        this.otherEmailCache = (evt.target as HTMLInputElement).value;
    }

    init(): void {
        this.recipientTypeInputSelf.addEventListener(
            'change',
            this.onSelectSelf.bind(this),
        );

        this.recipientTypeInputOther.addEventListener(
            'change',
            this.onSelectOther.bind(this),
        );

        this.recipientSenderShowNameTrue.addEventListener(
            'change',
            this.onSelectShowNameTrue.bind(this),
        );

        this.recipientSenderShowNameFalse.addEventListener(
            'change',
            this.onSelectShowNameFalse.bind(this),
        );

        this.recipientEmailInput.addEventListener(
            'input',
            this.onChangeEmailValue.bind(this),
        );

        this.selfOriginalEmail = this.recipientEmailInput.value;

        if (this.recipientTypeInputSelf.checked) {
            this.onSelectSelf(null);
        }

        if (this.recipientTypeInputOther.checked) {
            this.onSelectOther(null);
        }

        if (this.recipientSenderShowNameTrue.checked) {
            this.onSelectShowNameTrue();
        }

        if (this.recipientSenderShowNameFalse.checked) {
            this.onSelectShowNameFalse();
        }
    }
}
